export default __webpack_public_path__ + "static/media/dulces_detail5.9b124e0d.jpg";